import { createFileRoute, redirect } from "@tanstack/react-router";

import { UnmatchedPage } from "@/features/imaging/UnmatchedPage";

export const Route = createFileRoute("/_app/unmatched")({
  beforeLoad: ({ context }) => {
    // Only a laptop receives images it has not asked for; cloud images are always uploaded to a screening.
    if (context.info.edition !== "local") throw redirect({ to: "/worklist" });
  },
  component: UnmatchedPage,
});
